import { GLOSSARY_DESCRIPTION_TYPE } from '@/modules/dashboard/api/user-guide';

export default class GlossaryTerm {
  constructor({ type = GLOSSARY_DESCRIPTION_TYPE.TEXT, description, additionalData }) {
    this.type = type;
    this.description = description;
    this.additionalData = additionalData;
  }
}
